import React from 'react'

const NoAuthLayout = ({ children }) => (
  <div className="main d-flex w-100">{children}</div>
)

export default NoAuthLayout
